import * as Yup from 'yup';

export const model = {
  subject: {
    name: 'subject',
    type: 'text',
    placeholder: 'Subject',
  },
  message: {
    name: 'message',
    inputType: 'textarea',
    placeholder: 'Write your comment here',
  },
  screenshot: {
    name: 'screenshot',
    type: 'file',
    placeholder: 'Screenshot proof...',
  },
};

export const validationSchema = Yup.object().shape({
  [model.subject.name]: Yup.string().required('Required'),
  [model.message.name]: Yup.string().required('Required'),
});

export const initialValues = {
  [model.subject.name]: '',
  [model.message.name]: '',
};
